import React from 'react'
import SEO from '../components/SEO'
import Hero from '../components/home/Hero'
import LocationsSection from '../components/home/LocationsSection'
import StatsBanner from '../components/home/StatsBanner'
import FeaturedProperties from '../components/home/FeaturedProperties'
import Testimonials from '../components/home/Testimonials'
import CallToAction from '../components/home/CallToAction'
import FAQSection from '../components/home/FAQSection'
import ContactSection from '../components/home/ContactSection'

const Home = () => {

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Chapter24",
    "image": "https://chapter24.co.in/logo.png",
    "logo": "https://chapter24.co.in/logo.png",
    "url": "https://chapter24.co.in",
    "description": "Premium accommodation platform dedicated to providing safe and comfortable PG stays for working women in Pune.",
    "telephone": "+919960697118",
    "email": "info@chapter24.co.in",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  };

  return (
    <main>
      <SEO
        title="Chapter24 - Best Girls PG in Pune & Premium Coliving"
        description="Find the best premium girls PG accommodations and coliving spaces in Pune. Safe, affordable, verified listings with zero brokerage and easy booking."
        url="/"
      >
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </SEO>

      <Hero />
      <LocationsSection />
      <StatsBanner />
      <FeaturedProperties />
      <CallToAction />
      <FAQSection />
      <Testimonials />
      <ContactSection />
    </main>
  )
}

export default Home
